import { useCallback, useState, useEffect } from "react"
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap"
import BreadCrumb from "../../Components/BreadCrumb"
import Summary from "./components/Summary"
import Survey from "./Survey"

import { api } from "../../apis/surveys/api"

const Surveys = ({ location }) => {
    const [active, setActive] = useState("")
    const [loadedSurveys, setLoadedSurveys] = useState({})
    const [openSurveys, setOpenSurveys] = useState({})

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            const res = await api.getSurveys(100, null)
            if (res && res.data.code === 200) {
                const surveys_ = res.data.data.Items
                let items = {}
                console.log(res)
                for (let index = 0; index < surveys_.length; index++) {
                    const survey = surveys_[index]
                    items[`${survey.id.S}`] = {
                        id: survey.id.S,
                        inserted: survey.inserted.N,
                        network: survey.network.S,
                        contractAddress: survey.contract.S,
                        contractType: survey.contract_type.S,
                        title: survey.title.S,
                        surveyId: survey.survey_id.N,
                        creator: survey.creator.S
                    }
                }

                if (isSubscribed) {
                    setLoadedSurveys(items)
                }
                console.log(items)
            }
        }

        fetchData().catch(console.error)

        return () => (isSubscribed = false)
    }, [])

    const handleExpanded = useCallback(
        (surveyId) => {
            if (surveyId === active) {
                setActive("")
            } else {
                setActive(surveyId)
            }
        },
        [active]
    )

    const openForAnswer = (surveyId, isOpen) => {
        if (isOpen) {
            setOpenSurveys({ ...openSurveys, [surveyId]: { open: true } })
            openSurveys[surveyId] = true
        }
    }

    const survey = new URLSearchParams(location.search).get("id")?.toLowerCase()

    return (
        <>
            {survey ? (
                <Survey survey={loadedSurveys[survey]} />
            ) : (
                <div className="content survey-page">
                    <BreadCrumb current="Survey Dashboard" />
                    <div className="survey-body">
                        <Card>
                            <CardHeader>
                                <CardTitle className="h3">Idexo Surveys</CardTitle>
                            </CardHeader>
                            <CardBody className="dashboard pt-0">
                                <div className="token-info ">
                                    <div>
                                        <div className="title">Total Surveys</div>
                                        <div className="value">{Object.keys(loadedSurveys).length ?? 0}</div>
                                    </div>
                                    <div>
                                        <div className="title">Open Surveys</div>
                                        <div className="value">{Object.keys(openSurveys).length ?? 0}</div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <div className="pools-body">
                                    <div className="pools-header">
                                        <div>Chain</div>
                                        <div>Survey Title</div>
                                        <div>Total Questions</div>
                                        <div>Total Responses</div>
                                        <div>is Open</div>
                                    </div>

                                    {Object.keys(loadedSurveys).map((key) => {
                                        return (
                                            <Summary
                                                key={loadedSurveys[key].id}
                                                survey={loadedSurveys[key]}
                                                active={active}
                                                onExpand={handleExpanded}
                                                openForAnswer={openForAnswer}
                                            />
                                        )
                                    })}
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            )}
        </>
    )
}

export default Surveys
